import type { IAiUsageConfig } from '@ztechapps/common.contract'
import { AiBillingScopeEnum, AiCatalogWriteGateEnum } from '@ztechapps/common.contract'

// The credit balance is shared by the tenant, as Payroll's `payrollAiUsageConfig`. No PanelPunches feature debits
// credits yet, so the balance and the transaction list stay empty.
export const panelpunchesAiUsageConfig: IAiUsageConfig = {
  billingScope: AiBillingScopeEnum.Tenant,
  defaultCurrency: 'USD',
  catalogWriteGate: AiCatalogWriteGateEnum.SuperAdmin,
}
